import BigNumber from 'bignumber.js';
import { RawVolume, Volume } from '#/leaderboard/entities/volume';
import { UserFirm } from '#/leaderboard/entities/shared';
import {
  LiquidityFill,
  LiquidityResponse,
  RawLiquidityFill,
  RawLiquidityResponse,
} from '#/leaderboard/entities/liquidity';
import { Maybe } from '@paradigm/utils/types';

export function processVolume(
  rawVolume: RawVolume,
  userFirm: Maybe<UserFirm>,
): Volume {
  return {
    firmName: rawVolume.firm_name,
    isFromUser: rawVolume.firm_name === userFirm?.name,
    totalVolume: BigNumber(rawVolume.total_volume),
    totalShare: BigNumber(rawVolume.total_share),
    makerVolume: BigNumber(rawVolume.maker_volume),
    makerShare: BigNumber(rawVolume.maker_share),
    takerVolume: BigNumber(rawVolume.taker_volume),
    takerShare: BigNumber(rawVolume.taker_share),
  };
}

export function processLiquidityFill(
  raw: RawLiquidityFill,
  userFirm: Maybe<UserFirm>,
): LiquidityFill {
  return {
    firmName: raw.firm_name,
    isFromUser: raw.firm_name === userFirm?.name,
    totalReceived: BigNumber(raw.total_received),
    quoteRate: BigNumber(raw.quote_rate),
    fillRate: BigNumber(raw.fill_rate),
    fillToQuoteRate: BigNumber(raw.fill_to_quote_rate),
    spreadRank: BigNumber(raw.spread_rank),
    secondBestRate: BigNumber(raw.second_best_rate),
    totalVolume: BigNumber(raw.total_volume),
  };
}

export function processLiquidityResponse(
  raw: RawLiquidityResponse,
  userFirm: Maybe<UserFirm>,
): LiquidityResponse {
  return {
    firmName: raw.firm_name,
    isFromUser: raw.firm_name === userFirm?.name,
    totalReceived: BigNumber(raw.total_received),
    quoteRate: BigNumber(raw.quote_rate),
    medianResponseTime: BigNumber(raw.median_response_time),
    under5sResponse: BigNumber(raw.response_time_under_5s_rate),
    under20sResponse: BigNumber(raw.response_time_under_20s_rate),
    under60sResponse: BigNumber(raw.response_time_under_60s_rate),
    over60sResponse: BigNumber(raw.response_time_above_60s_rate),
  };
}
